import { c as _c } from "react/compiler-runtime";
import type { NextPage } from "next";
import { Aktivitetskrav } from "@/components/Aktivitetskrav";
import { AktivitetskravSkeletonComponent } from "@/components/skeleton/AktivitetskravSkeletonComponent";
import { useAktivitetskravData } from "@/data/dataHooks";
const Home: NextPage = () => {
  const $ = _c(3);
  const {
    isPending,
    error,
    data
  } = useAktivitetskravData();
  if (error) {
    throw error;
  }
  let t0;
  if ($[0] !== data || $[1] !== isPending) {
    t0 = isPending ? <AktivitetskravSkeletonComponent /> : <Aktivitetskrav aktivitetskrav={data} />;
    $[0] = data;
    $[1] = isPending;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Home;